import {getApiUrl} from "../utils/util-functions";

export const acceptSignaturesAsync = async (signatures: string[], is_preview: boolean, selectedOptionId: number, selectedAddOnOptionIds: number[] = [], previewSearchString: string = '', signerName: string) => {
    let path = getApiUrl() + '/accept-signatures';
    if (is_preview) {
        path = `${path}${previewSearchString}`;
    }
    return fetch(path, {
        method: 'POST',
        body: JSON.stringify({
            signatures,
            is_preview,
            selected_option_id: selectedOptionId,
            selected_add_on_options_ids: selectedAddOnOptionIds,
            signature_name: signerName
        })
    })
        .then((response) => {
            return response.json();
        })
        .then((response: any) => {
            return response;
        });
}

export const rejectSignaturesAsync = async (rejectReason: string) => {
    return fetch(getApiUrl() + '/reject-signature', {
        method: 'POST',
        body: JSON.stringify({reject_reason: rejectReason})
    })
        .then((response) => {
            return response.json();
        })
        .then((response: any) => {
            return response;
        });
}
